// config.js should be loaded already
const { configuration } = window;
if (!configuration) {
    throw new Error(
        'No configuration was found! Check if config.js was loaded correctly.'
    );
}

export default configuration;
